import React from "react";
import ReactDOM from "react-dom/client";

import App from "./views/components/app";
import { brand } from "./configs/brand";
import "./index.css";

// Theme the browser tab at runtime so it reflects the brand in dev and prod without a
// rebuild; the static index.html <title> is only the default/pre-JS fallback.
document.title = brand.displayName;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
